<template>
    <biller-modal :isVisible="showModal">
        <div class="p-8 modal-width text-center">
            <p class="text-base text-grey-300 font-semibold my-5">Education Transfer Reference</p>
            <div class="mt-12 mb-10">
                <p class="text-smoke-100 text-sm">
                    {{ Object.entries(data).length ? data.content.transactions.product_name : 'Token' }}
                </p>
                <div class="flex items-center justify-center relative">
                    <p class="font-medium text-grey-300 mt-2 text-2xl" ref="token">
                        {{ Object.entries(data).length ? data.tokens[0] : '0000000000000' }}
                    </p>
                    <div class="absolute top-0 right-0  pr-2" @click="copyToClipboard('token', 'token')">
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="#C0CCDA"
                            xmlns="http://www.w3.org/2000/svg"
                            class="ml-3 cursor-pointer"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M6 10V9C6 7.346 7.346 6 9 6H10V2.667C10 2.299 9.701 2 9.333 2H2.667C2.299 2 2 2.299 2 2.667V9.333C2 9.701 2.299 10 2.667 10H6ZM6 12H2.667C1.196 12 0 10.804 0 9.333V2.667C0 1.196 1.196 0 2.667 0H9.333C10.804 0 12 1.196 12 2.667V6H15C16.654 6 18 7.346 18 9V15C18 16.654 16.654 18 15 18H9C7.346 18 6 16.654 6 15V12ZM8 9C8 8.449 8.449 8 9 8H15C15.552 8 16 8.449 16 9V15C16 15.551 15.552 16 15 16H9C8.449 16 8 15.551 8 15V9Z"
                            />
                        </svg>
                    </div>
                </div>
            </div>

            <div class="mt-16 mb-5">
                <button
                    @click="$emit('close')"
                    class="font-semibold bg-orange-pale text-base text-orange px-6 py-4 rounded-lg"
                >
                    Close
                </button>
            </div>
        </div>
    </biller-modal>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },

        data: {
            type: Object,
        },
    },

    methods: {
        ...mapActions('Message', {
            setMessage: 'SET_MESSAGE',
        }),

        copyToClipboard(content, item) {
            const textToCopy = this.$refs[content].textContent
            const inputField = document.createElement('input')

            inputField.value = textToCopy
            document.body.appendChild(inputField)

            inputField.select()
            document.execCommand('copy')
            inputField.remove()

            this.setMessage('Successfully copied ' + item + ' to clipboard')
        },
    },
}
</script>

<style scoped>
@media screen and (min-width: 640px) {
    .modal-width {
        width: 400px;
    }
}

.modal-width {
    min-width: 320px;
}
</style>
